import { Menu } from 'antd';
import { setLocaleTempUsingCookies, setLocaleUsingCookies } from 'core/common-methods';
import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AppConstants } from '../../core/app.constants';
import downArrow from '../../assets/icons/downArrow.svg';
import './style.less';
import { translationWrapper } from 'utils/common-methods';
  // tslint:disable
type ChildProps = {
  hideTitleWhenSelectedLang?: boolean;
};
 // tslint:enable
const StyledText = styled.div`
  color: #14151c;
  
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.0075em;
`;

const defaultLang = { value: 'en', name: 'English (USA)', shortLabel: 'EN' }

export const LanguageDropdown: React.FC<ChildProps> = (
  props: any,
): React.ReactElement => {
  const { t } = translationWrapper(useTranslation());
  const [currentLanguage, setCurrentLang] = React.useState<any>({});
  const handleSelect = (e: any) => {
    const currentLang = AppConstants.SUPPORTED_LANGS.find(
      (lang) => lang.value === e.key,
    );
    localStorage.setItem('currentLanguage', e.key);
    i18next.changeLanguage(e.key || 'en');
    setLocaleTempUsingCookies(e.key || 'en');
    setLocaleUsingCookies(e.key || 'en');
    setCurrentLang(currentLang);
  };
  const getLanguageCode = (selectedLang: any) => {
    return selectedLang.includes("en-US") ? "en": selectedLang;
  };
  // tslint:disable-next-line: no-multi-spaces
  const Lang = localStorage.getItem('i18nextLng') || localStorage.getItem('currentLanguage');
  React.useEffect(() => {
    const currentLang = AppConstants.SUPPORTED_LANGS.find(
      (lang) => lang.value === getLanguageCode(Lang),
    );
    setCurrentLang(currentLang || defaultLang);
  }, [Lang]);
  return (
    <div className="render-btn">
      <Menu onClick={handleSelect} overflowedIndicator={false} theme="light" selectedKeys={[currentLanguage?.value]}>
        <Menu.SubMenu
           // tslint:disable
          title={
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                  gap: '7px'
                }}
              >
                <StyledText>{props.hideTitleWhenSelectedLang && currentLanguage?.name ? '' : t('global.title.language')}</StyledText>
                <StyledText style={{ color: '#4D5165' }}>
                  {t(`global.supported_language.${currentLanguage?.name}`)}
                <img className='drop-down-icon' src={downArrow}/>
                </StyledText>
              </div>
            </>
          }
           // tslint:enable
        >
          {AppConstants.SUPPORTED_LANGS.map((v) => {
            return (
              <Menu.Item
                className={`language-menu-item language-menu-item-${v.value}`}
                key={v.value}
              >
                {t(`global.supported_language.${v.name}`)}
              </Menu.Item>
            );
          })}
        </Menu.SubMenu>
      </Menu>
    </div>
  );
};
